(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
if (!customElements.get('bt-footer-menus')) {
  customElements.define('bt-footer-menus', class extends HTMLElement {
    connectedCallback() {
      this.breakpoint = window.matchMedia('(max-width: 767px)');
      this.updateLayout = () => {
        this.querySelectorAll('details').forEach(details => {
          details.open = !this.breakpoint.matches;
          const summary = details.querySelector('summary');
          if (this.breakpoint.matches) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
      };
      this.updateLayout();
      this.breakpoint.addEventListener('change', this.updateLayout);
    }
    disconnectedCallback() {
      this.breakpoint.removeEventListener('change', this.updateLayout);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
